module.exports = __webpack_public_path__ + "static/img/computer.92c3860.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/login/img/computer.png
// module id = CtAV
// module chunks = 110